import styled from '@emotion/styled';

export const LogInScreen = styled.div`
  display: none;
  @media (min-width: 768px) {
    display: block;
    background-color: #f0f0f0;
    height: 100vh;
    overflow: hidden;
    position: relative;
  }
`;
export const TopBarLayout = styled.div`
  background-color: #e9e9e9;
  height: 48px;
  width: 100%;
`;
export const MainSectionLayout = styled.div`
  padding: 40px;
  @media (min-width: 1260px) {
    display: flex;
    justify-content: center;
  }
`;
export const InnerMainSectionLayout = styled.div`
  @media (min-width: 1260px) {
    max-width: 698px;
  }
  @media (min-width: 1630px) {
    max-width: 945px;
  }
`;
export const MiddleBar = styled.div`
  height: 112px;
  background-color: #e9e9e9;
  width: 100%;
  margin-bottom: 16px;
`;
export const OuterMiniBoxes = styled.div`
  display: flex;
  justify-content: space-between;
`;
export const MiniBox = styled.span`
  background-color: #e9e9e9;
  height: 104px;
  margin-right: 16px;
  width: 363px;
  :last-of-type {
    margin-right: 0;
  }
`;
export const SmallRectangle = styled.div`
  background-color: #e9e9e9;
  height: 24px;
  margin-top: 56px;
  width: 76px;
`;
export const WideRectangle = styled.div`
  background-color: #e9e9e9;
  height: 24px;
  margin-top: 8px;
  width: 100%;
`;
export const BottomSquare = styled.div`
  background-color: #e9e9e9;
  height: 600px;
  margin-top: 8px;
  width: 100%;
`;
export const RightRectangle = styled.div`
  @media (max-width: 1259px) {
    display: none;
  }
  @media (min-width: 1260px) {
    background-color: #e9e9e9;
    height: 825px;
    width: 335px;
    margin-left: 25px;
  }
  @media (min-width: 1630px) {
    width: 458px;
  }
`;
export const HudsonLogoStyles = styled.div`
  @media (max-width: 767px) {
    display: none;
  }
  @media (min-width: 768px) {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 10%);
  }
`;
export const OuterLogIn = styled.div<{ maxHeight?: string }>`
  background-color: #f5f5f5;
  width: 100%;
  height: 100vh;
  position: absolute;
  overflow: hidden;
  @media (min-width: 768px) {
    top: 50px;
    max-width: 576px;
    max-height: ${(props) => (props.maxHeight ? props.maxHeight : '650px')};
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 56px 80px;
    img{
      display: none;
    }
  }
`;
export const LogInHeader = styled.div`
  font-weight: 600;
  font-size: 28px;
  margin-top:40px;
  @media (min-width: 768px) {
    font-size: 32px;
    margin-bottom: 8px;
  }
`;
export const SubHeader = styled.div`
  display: none;
  @media (min-width: 768px) {
    display: block;
    font-size: 16px;
    margin-bottom: 36px;
    color: #33322f;
    max-width: 450px;
    margin-top:16px;
  }
`;
export const PasswordConditions = styled.div`
margin-top:12px;
@media (min-width: 768px) {
    margin-left: 32px;
    margin-top:16px;
  }
`
export const InputMobile = styled.div`
  margin-top: 47px;
  margin-bottom: 53px;
  @media (min-width: 768px) {
    display: none;
  }
`;
export const InputDesktop = styled.div`
 display: none;
  @media (min-width: 768px) {
    display: block;
    margin-top:36px;
  }
`;
export const ButtonMobile = styled.div`
margin-bottom: 8px;
  @media (min-width: 768px) {
    display: none;
  }
`;
export const ButtonDesktop = styled.div`
 display: none;
  @media (min-width: 768px) {
    display: block;
    margin-bottom: 8px;
    margin-top:96px;
  }
`;
export const ResetWrapper = styled.div`
  margin:100px 16px 0 16px;
  height: 100vh;
`;
export const Reset = styled.div`
  font-size: 24px;
`
